import React, { useEffect, useState } from "react";
import dropdown from "../assets/dropdown.png";
import base from "../assets/base.png";
import polygon from "../assets/polygon.png";
import down from "../assets/down.png";
import eth from "../assets/eth.png";
import gas from "../assets/gas.png";
import TokenModal from "./TokenDialog";
import SlippageSettings from "./SlippageSettings";
import { IoSettings } from "react-icons/io5";
import { useParams, useNavigate } from "react-router-dom";
import coin from "../assets/complere.png";
import {
    getErc20Contract,
    getFactoryContract,
    getRouterContract,
    getWalletBalanceContract,
    ThirdWebClient,
} from "../contexts/thirdWebClient";
import { allowance, approve, balanceOf } from "thirdweb/extensions/erc20";
import { routerAddress, WETHAddress } from "../contexts/config";
import {
    useActiveAccount,
    useActiveWalletChain,
    useSendTransaction,
} from "thirdweb/react";
import { prepareContractCall, readContract, sendTransaction as sendTx, waitForReceipt } from "thirdweb";
import { toast } from "react-toastify";
import { createPool } from "thirdweb/extensions/uniswap";
import { ethers } from "ethers";
import { getCurrencyMetadata } from "thirdweb/extensions/erc20";
import { getWalletBalance } from "thirdweb/wallets";
import { safeFixedString } from "../utility/formatNumber";

// Truncate a number to N decimals for display (never rounds up past actual value).
const truncateDisplay = (num, decimals) => {
    if (num === null || num === undefined || isNaN(num) || Number(num) === 0) return "0";
    const factor = Math.pow(10, decimals);
    return (Math.floor(Number(num) * factor) / factor).toFixed(decimals);
};

const AddLiquidity = () => {
    const [open, setOpen] = useState(false);
    const [openBuy, setOpenBuy] = useState(false);
    const [selected, setSelected] = useState({});
    const [selectedBuy, setSelectedBuy] = useState({});
    const [loading, setLoading] = useState(false);
    const [approvingToken, setApprovingToken] = useState(null);
    const [balanceLoading, setBalanceLoading] = useState(false);
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [checkData, setCheckData] = useState(false);
    const [settingsOpen, setSettingsOpen] = useState(false);
    const [slippage, setSlippage] = useState(() => {
        const saved = localStorage.getItem("perpx_slippage");
        return saved ? parseFloat(saved) : 1;
    });

    const add = useActiveAccount();
    const [address, setAddress] = useState("");
    const chain = useActiveWalletChain();
    useEffect(() => {
        if (add && add.address) {
            console.log("%c Line:41 🍅 add", "color:#7f2b82", add);
            setAddress(add.address);
        }
    }, [add, chain]);
    let navigate = useNavigate();
    const { address1, address2 } = useParams();

    useEffect(() => {
        const fetchData = async () => {
            if (address1) {
                const tokenData = await tokenDetails(address1);
                setSelected(tokenData);
            }
            if (address2) {
                const tokenData = await tokenDetails(address2);
                setSelectedBuy(tokenData);
            }
            setCheckData(true);
        };
        fetchData();
    }, [address1, address2, add, chain]);

    const [token1Details, setToken1Details] = useState({});
    const [token2Details, setToken2Details] = useState({});

    const [token1value, setToken1value] = useState(0);
    const [token2value, setToken2value] = useState(0);

    const [price, setPrice] = useState(1);

    const tokenDetails = async (value) => {
        try {
            if (value && value !== "" && chain && chain?.id && chain?.rpc) {
                // Native ETH has no ERC20 contract — return metadata directly
                if (value === "0x0000000000000000000000000000000000000000") {
                    return {
                        name: "Ethereum",
                        symbol: "ETH",
                        decimals: 18,
                        address: value,
                    };
                }
                const contract = getErc20Contract(value, chain);
                let currencyMetadata = await getCurrencyMetadata({ contract });
                currencyMetadata.address = value;
                return currencyMetadata;
            } else {
                return false;
            }
        } catch (error) {
            return false;

            //   toast.error(error?.message)
            //   console.log("%c Line:53 🍎 error", "color:#6ec1c2", error);
        }
    };

    useEffect(() => {
        if (checkData) {
            let route = `/pool/addliquidity/`;
            if (selected && selected !== "" && selected.address !== address1) {
                route += selected.address + "/";
            } else {
                route += address1 + "/";
            }
            if (
                selectedBuy &&
                selectedBuy !== "" &&
                selectedBuy.address !== address2
            ) {
                route += selectedBuy.address;
            } else {
                route += address2;
            }
            navigate(route);
        }
    }, [selected, selectedBuy]);

    useEffect(() => {
        const getData = async () => {
            if (!chain || !address) return;
            setBalanceLoading(true);
            try {
                if (
                    selected &&
                    selected !== "" &&
                    selected?.address &&
                    selected?.address !=
                        "0x0000000000000000000000000000000000000000"
                ) {
                    const contract = getErc20Contract(selected.address, chain);
                    let approvedAmount = await allowance({
                        contract,
                        owner: address,
                        spender: routerAddress,
                    });
                    let tokenBalance = await balanceOf({
                        contract,
                        address: address,
                    });
                    setToken1Details({
                        ...selected,
                        approvedBalance: Number(
                            ethers.formatUnits(approvedAmount, selected?.decimals),
                        ),
                        balance: Number(
                            ethers.formatUnits(tokenBalance, selected?.decimals),
                        ) * 1,
                    });
                }
                if (
                    selected &&
                    selected !== "" &&
                    selected?.address ==
                        "0x0000000000000000000000000000000000000000"
                ) {
                    let tokenBalance = await getWalletBalanceContract(
                        address,
                        chain,
                    );
                    setToken1Details({
                        ...selected,
                        approvedBalance: Number(100000000000) * 1,
                        balance: Number(ethers.formatUnits(tokenBalance, 18)) * 1,
                    });
                }
                if (
                    selectedBuy &&
                    selectedBuy !== "" &&
                    selectedBuy?.address &&
                    selectedBuy?.address !=
                        "0x0000000000000000000000000000000000000000"
                ) {
                    const contract = getErc20Contract(selectedBuy.address, chain);
                    let approvedAmount = await allowance({
                        contract,
                        owner: address,
                        spender: routerAddress,
                    });
                    let tokenBalance = await balanceOf({
                        contract,
                        address: address,
                    });
                    setToken2Details({
                        ...selectedBuy,
                        approvedBalance: Number(
                            ethers.formatUnits(approvedAmount, selectedBuy?.decimals),
                        ),
                        balance: Number(
                            ethers.formatUnits(tokenBalance, selectedBuy?.decimals),
                        ) * 1,
                    });
                }
                if (
                    selectedBuy &&
                    selectedBuy !== "" &&
                    selectedBuy?.address ==
                        "0x0000000000000000000000000000000000000000"
                ) {
                    let tokenBalance = await getWalletBalanceContract(
                        address,
                        chain,
                    );
                    setToken2Details({
                        ...selectedBuy,
                        approvedBalance: Number(100000000000) * 1,
                        balance: Number(ethers.formatUnits(tokenBalance, 18)) * 1,
                    });
                }
            } catch (error) {
                console.log("getData error:", error);
            }
            setBalanceLoading(false);
        };
        getData();
    }, [selected, selectedBuy, loading, refreshTrigger, chain, address]);

    const approveTokenFun = async (tokenAddress, tokenSymbol) => {
        try {
            setApprovingToken(tokenAddress);
            const contract = getErc20Contract(tokenAddress, chain);
            const transaction = approve({
                contract,
                spender: routerAddress,
                amountWei: ethers.MaxUint256,
            });
            const tx = await sendTx({ transaction, account: add });
            console.log("%c Line:118 🥔 tx", "color:#93c0a4", tx);
            toast.success(`${tokenSymbol} approved`);
            setRefreshTrigger((prev) => prev + 1);
            setApprovingToken(null);
        } catch (error) {
            toast.error(error?.message);
            setApprovingToken(null);
            console.log("%c Line:111 🍫 error", "color:#ed9ec7", error);
        }
    };

    const { mutate: sendTransaction } = useSendTransaction();

    // Calculate minimum amount with slippage
    const calculateMinAmount = (amount, decimals) => {
        try {
            const slippageMultiplier = (100 - slippage) / 100;
            const minAmount = parseFloat(amount) * slippageMultiplier;
            return ethers.parseUnits(safeFixedString(minAmount, decimals), decimals);
        } catch (error) {
            console.log("Error calculating min amount:", error);
            return "1"; // Fallback
        }
    };

    const addLiquidity = async () => {
        try {
            // Check sufficient balances before sending transaction
            if (parseFloat(token1value) > (token1Details?.balance || 0)) {
                toast.error(`Insufficient ${token1Details?.symbol} balance`);
                return;
            }
            if (parseFloat(token2value) > (token2Details?.balance || 0)) {
                toast.error(`Insufficient ${token2Details?.symbol} balance`);
                return;
            }

            setLoading(true);
            const contract = getRouterContract(chain);

            const token1Decimals = token1Details?.decimals;
            const token2Decimals = token2Details?.decimals;

            let token1amount = ethers.parseUnits(
                safeFixedString(token1value, token1Decimals),
                token1Decimals,
            );

            let token2amount = ethers.parseUnits(
                safeFixedString(token2value, token2Decimals),
                token2Decimals,
            );

            let transaction;
            if (
                token1Details?.address ==
                    "0x0000000000000000000000000000000000000000" ||
                token2Details?.address ==
                    "0x0000000000000000000000000000000000000000"
            ) {
                transaction = prepareContractCall({
                    contract,
                    method: "function addLiquidityETH(address token, uint256 amountTokenDesired, uint256 amountTokenMin, uint256 amountETHMin, address to, uint256 deadline) payable returns (uint256 amountToken, uint256 amountETH, uint256 liquidity)",
                    params: [
                        token1Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                            ? token2Details?.address
                            : token1Details?.address,
                        token1Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                            ? token2amount
                            : token1amount,
                        1, //calculateMinAmount(token1Details?.address == "0x0000000000000000000000000000000000000000" ? token2value : token1value, token1Details?.address == "0x0000000000000000000000000000000000000000" ? token2Details?.decimals : token1Details?.decimals),
                        1, //calculateMinAmount(token1Details?.address == "0x0000000000000000000000000000000000000000" ? token1value : token2value, token1Details?.address == "0x0000000000000000000000000000000000000000" ? token1Details?.decimals : token2Details?.decimals),
                        address,
                        Math.floor(new Date().getTime() / 1000) + 900,
                    ],
                    value:
                        token1Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                            ? token1amount
                            : token2amount,
                });
            } else {
                transaction = prepareContractCall({
                    contract,
                    method: `function addLiquidity(address tokenA, address tokenB, uint256 amountADesired,uint256 amountBDesired,uint256 amountAMin,uint256 amountBMin,address to,uint256 deadline)`,
                    params: [
                        token1Details?.address,
                        token2Details?.address,
                        token1amount,
                        token2amount,
                        1, //calculateMinAmount(token1value, token1Details?.decimals),
                        1, //calculateMinAmount(token2value, token2Details?.decimals),
                        address,
                        Math.floor(new Date().getTime() / 1000) + 900,
                    ],
                });
            }
            const txData = await sendTx({ transaction, account: add });
            console.log("%c Line:173 🥐 txData", "color:#3f7cff", txData);

            // Wait for transaction confirmation so the LP balance is on-chain
            // before Pool page reads it. Without this, Pool reads stale 0 balance.
            await waitForReceipt({
                client: ThirdWebClient,
                chain,
                transactionHash: txData.transactionHash,
            });

            toast.success("Liquidity Added");

            // Reset input values after successful liquidity addition
            setToken1value(0);
            setToken2value(0);

            setLoading(false);

            // Redirect to pool page with refresh state
            navigate('/pool', { state: { refresh: true } });
        } catch (error) {
            const msg = error?.message || "";
            if (msg.includes("transferFrom failed")) {
                toast.error(
                    `Insufficient balance or token not approved. Please ensure you have enough ${token1Details?.symbol} and ${token2Details?.symbol}, and both are approved.`
                );
            } else {
                toast.error(msg);
            }
            setLoading(false);
            console.log("%c Line:166 🍕 error", "color:#f5ce50", error);
        }
    };

    useEffect(() => {
        if (token1Details.address && token2Details.address) {
            fetchLpDetails();
        }
    });

    const [lpAddress, setLpAddress] = useState(false);
    const [token1LpBalance, setToken1LpBalance] = useState(0);
    const [token2LpBalance, setToken2LpBalance] = useState(0);

    const fetchLpDetails = async () => {
        try {
            const routerContract = await getRouterContract(chain);
            const factoryContract = await getFactoryContract(chain);

            let pairAddress = await readContract({
                contract: factoryContract,
                method: "function getPair(address, address) view returns (address)",
                params: [
                    token1Details?.address ==
                    "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token1Details?.address,
                    token2Details?.address ==
                    "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token2Details?.address,
                ],
            });

            if(pairAddress != "0x0000000000000000000000000000000000000000"){
                setLpAddress(true);
                console.log(
                    "%c Line:224 🍧 pairAddress",
                    "color:#7f2b82",
                    pairAddress,
                );
    
                const Token0contract = getErc20Contract(
                    token1Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token1Details?.address,
                    chain,
                );
                let tokenOUserBalance = await balanceOf({
                    contract: Token0contract,
                    address: pairAddress,
                });
                setToken1LpBalance(tokenOUserBalance);
    
                const Token1contract = getErc20Contract(
                    token2Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token2Details?.address,
                    chain,
                );
    
                let token1UserBalance = await balanceOf({
                    contract: Token1contract,
                    address: pairAddress,
                });
                setToken2LpBalance(token1UserBalance);
    
                let tokenPrice = await readContract({
                    contract: routerContract,
                    method: "function quote(uint256 amountA, uint256 reserveA, uint256 reserveB) pure returns (uint256 amountB)",
                    params: [
                        ethers.parseUnits("1", selected?.decimals),
                        tokenOUserBalance,
                        token1UserBalance,
                    ],
                });
    
                setPrice(
                    Number(
                        ethers.formatUnits(tokenPrice, selectedBuy?.decimals),
                    ).toFixed(5),
                );
            }else {
                setPrice(0)
            }
        } catch (error) {
            console.log("%c Line:47 🍉 error", "color:#42b983", error);
        }
    };

    const fetchPriceDetails = async (value) => {
        try {
            // Clear token2 value if input is empty or invalid
            if (!value || value === '' || parseFloat(value) <= 0) {
                setToken2value(0);
                return;
            }

            if(lpAddress && token1LpBalance > 0 && token2LpBalance > 0){
                const routerContract = await getRouterContract(chain);

                let token0Price = await readContract({
                    contract: routerContract,
                    method: "function quote(uint256 amountA, uint256 reserveA, uint256 reserveB) pure returns (uint256 amountB)",
                    params: [
                        ethers.parseUnits(safeFixedString(value, selected?.decimals), selected?.decimals),
                        token1LpBalance,
                        token2LpBalance,
                    ],
                });

                setToken2value(
                    safeFixedString(
                        ethers.formatUnits(token0Price, selectedBuy?.decimals),
                        selectedBuy?.decimals,
                    ),
                );
            }
        } catch (error) {
            console.log("%c Line:47 🍉 error", "color:#42b983", error);
        }
    };

    const fetchPrice2Details = async (value) => {
        try {
            // Clear token1 value if input is empty or invalid
            if (!value || value === '' || parseFloat(value) <= 0) {
                setToken1value(0);
                return;
            }

            if(lpAddress && token1LpBalance > 0 && token2LpBalance > 0){
                const routerContract = await getRouterContract(chain);

                let token0Price = await readContract({
                    contract: routerContract,
                    method: "function quote(uint256 amountA, uint256 reserveA, uint256 reserveB) pure returns (uint256 amountB)",
                    params: [
                        ethers.parseUnits(safeFixedString(value, selectedBuy?.decimals), selectedBuy?.decimals),
                        token2LpBalance,
                        token1LpBalance,
                    ],
                });
                setToken1value(
                    safeFixedString(
                        ethers.formatUnits(token0Price, selected?.decimals),
                        selected?.decimals,
                    ),
                );
            }
        } catch (error) {
            console.log("%c Line:47 🍉 error", "color:#42b983", error);
        }
    };

    return (
        <div className="max-w-[524px] mx-3 sm:mx-auto mt-10 flex gap-2 items-center flex-col p-5 rounded-xl bg-perpx-dark-tertiary/50 backdrop-blur-md border border-perpx-cyan/20">
            {/* Settings Icon */}
            <div className="w-full flex justify-end mb-2">
                <IoSettings
                    className="text-perpx-cyan cursor-pointer hover:text-perpx-cyan/80 transition-all size-[24px]"
                    onClick={() => setSettingsOpen(true)}
                    title="Slippage Settings"
                />
            </div>
            <div className="rounded-[16px] overflow-hidden border w-full border-perpx-cyan/20">
                <div className="bg-perpx-dark-secondary/80 text-perpx-text-primary flex justify-between text-[14px] sm:text-[16px] font-normal px-6 py-2 border-b border-perpx-cyan/10">
                    <h6>Token 1</h6>
                    {address && token1Details && token1Details?.symbol && (
                        <p>
                            Balance:
                            <b className="text-perpx-cyan ml-1">
                                {balanceLoading ? (
                                    <span className="animate-pulse">Loading...</span>
                                ) : (
                                    token1Details?.balance
                                        ? truncateDisplay(token1Details.balance, 4)
                                        : '0.0000'
                                )}
                            </b>
                        </p>
                    )}
                </div>
                <div className="bg-perpx-dark/90 text-perpx-text-primary flex items-center justify-between text-[14px] sm:text-[16px] font-normal px-6 py-2">
                    <div className="text-left">
                        <input
                            className="text-[30px] sm:text-[38px] font-semibold text-perpx-cyan bg-transparent outline-none"
                            style={{ width: "80%" }}
                            type="number"
                            min="0"
                            step="any"
                            value={token1value === 0 || token1value === '' ? '' : token1value}
                            placeholder="0"
                            onChange={(e) => {
                                setToken1value(e.target.value);
                                fetchPriceDetails(e.target.value);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </div>
                    <div
                        onClick={() => setOpen(!open)}
                        className="flex items-center justify-center gap-1 sm:gap-3 bg-perpx-dark-secondary rounded-[48px] border-2 border-perpx-cyan/30 hover:border-perpx-cyan/50 px-[9px] py-[4px] cursor-pointer transition-all"
                        style={{ width: "70%" }}
                    >
                        {selected && selected?.symbol ? (
                            <>
                                {selected?.emoji ? (
                                    <span className="text-[18px] sm:text-[22px]">{selected.emoji}</span>
                                ) : selected?.img ? (
                                    <img
                                        src={selected.img}
                                        alt={selected.symbol}
                                        className="size-[20px] sm:size-[26px] rounded-full"
                                    />
                                ) : null}
                                <h5 className="font-semibold text-[18px] sm:text-[22px] text-perpx-cyan">
                                    {selected?.symbol}
                                </h5>
                                <img
                                    src={dropdown}
                                    alt=""
                                    className="size-[18px] sm:size-[20px]"
                                />
                            </>
                        ) : (
                            <>
                                <h5 className="font-semibold text-[18px] sm:text-[16px] text-perpx-text-secondary">
                                    Select Token
                                </h5>
                                <img
                                    src={dropdown}
                                    alt=""
                                    className="size-[18px] sm:size-[20px]"
                                />
                            </>
                        )}
                    </div>
                </div>
            </div>
            <img src={down} className="my-[-21px] z-50 h-[50px] w-[50px] bg-white p-2 rounded-full shadow-lg" alt="Add liquidity" />
            <div className="rounded-[16px] overflow-hidden border w-full border-perpx-cyan/20">
                <div className="bg-perpx-dark-secondary/80 text-perpx-text-primary flex justify-between text-[14px] sm:text-[16px] font-normal px-6 py-2 border-b border-perpx-cyan/10">
                    <h6>Token 2</h6>
                    {address && token2Details && token2Details?.symbol && (
                        <p>
                            Balance:
                            <b className="text-perpx-cyan ml-1">
                                {balanceLoading ? (
                                    <span className="animate-pulse">Loading...</span>
                                ) : (
                                    token2Details?.balance
                                        ? truncateDisplay(token2Details.balance, 4)
                                        : '0.0000'
                                )}
                            </b>
                        </p>
                    )}
                </div>
                <div className="bg-perpx-dark/90 text-perpx-text-primary flex items-center justify-between text-[16px] font-normal px-6 py-2">
                    <div className="text-left">
                        <input
                            className="text-[30px] sm:text-[38px] font-semibold text-perpx-cyan bg-transparent outline-none"
                            style={{ width: "80%" }}
                            type="number"
                            min="0"
                            step="any"
                            value={token2value === 0 || token2value === '' ? '' : token2value}
                            placeholder="0"
                            onChange={(e) => {
                                setToken2value(e.target.value);
                                fetchPrice2Details(e.target.value);

                            }}
                            onKeyDown={(e) => {
                                if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </div>
                    <div
                        onClick={() => setOpenBuy(!openBuy)}
                        className="flex items-center justify-center gap-1 sm:gap-3 bg-perpx-dark-secondary border-2 border-perpx-cyan/30 hover:border-perpx-cyan/50 rounded-[48px] px-[9px] py-[4px] cursor-pointer transition-all"
                        style={{ width: "70%" }}
                    >
                        {selectedBuy && selectedBuy?.symbol ? (
                            <>
                                {selectedBuy?.emoji ? (
                                    <span className="text-[18px] sm:text-[22px]">{selectedBuy.emoji}</span>
                                ) : selectedBuy?.img ? (
                                    <img
                                        src={selectedBuy.img}
                                        alt={selectedBuy.symbol}
                                        className="size-[20px] sm:size-[26px] rounded-full"
                                    />
                                ) : null}
                                <h5 className="font-semibold text-[18px] sm:text-[22px] text-perpx-cyan">
                                    {selectedBuy?.symbol}
                                </h5>
                                <img
                                    src={dropdown}
                                    alt=""
                                    className="size-[18px] sm:size-[20px]"
                                />
                            </>
                        ) : (
                            <>
                                <h5 className="font-semibold text-[18px] sm:text-[16px] text-perpx-text-secondary">
                                    Select Token
                                </h5>
                                <img
                                    src={dropdown}
                                    alt=""
                                    className="size-[18px] sm:size-[20px]"
                                />
                            </>
                        )}
                    </div>
                </div>
            </div>
            {token1Details?.symbol && !(token1Details?.approvedBalance >= (parseFloat(token1value) || 0)) ? (
                approvingToken === token1Details?.address ? (
                    <button
                        className="bg-perpx-cyan mt-2 w-full rounded-[64px] py-[16px] px-[4px] text-perpx-dark text-[18px] font-semibold hover:shadow-perpx-glow-lg transition-all"
                        disabled
                    >
                        Approving {token1Details?.symbol}..
                    </button>
                ) : (
                    <button
                        className="bg-perpx-cyan mt-2 w-full rounded-[64px] py-[16px] px-[4px] text-perpx-dark text-[18px] font-semibold hover:shadow-perpx-glow-lg hover:scale-[1.02] transition-all"
                        onClick={() => approveTokenFun(token1Details?.address, token1Details?.symbol)}
                        disabled={!!approvingToken}
                    >
                        Approve {token1Details?.symbol}
                    </button>
                )
            ) : (
                ""
            )}
            {token2Details?.symbol && !(token2Details?.approvedBalance >= (parseFloat(token2value) || 0)) ? (
                approvingToken === token2Details?.address ? (
                    <button
                        className="bg-perpx-cyan mt-2 w-full rounded-[64px] py-[16px] px-[4px] text-perpx-dark text-[18px] font-semibold hover:shadow-perpx-glow-lg transition-all"
                        disabled
                    >
                        Approving {token2Details?.symbol}..
                    </button>
                ) : (
                    <button
                        className="bg-perpx-cyan mt-2 w-full rounded-[64px] py-[16px] px-[4px] text-perpx-dark text-[18px] font-semibold hover:shadow-perpx-glow-lg hover:scale-[1.02] transition-all"
                        onClick={() => approveTokenFun(token2Details?.address, token2Details?.symbol)}
                        disabled={!!approvingToken}
                    >
                        Approve {token2Details?.symbol}
                    </button>
                )
            ) : (
                ""
            )}
            {/* Only show Add Liquidity button when both tokens are approved and selected */}
            {token1Details?.approvedBalance >= (parseFloat(token1value) || 0) && token2Details?.approvedBalance >= (parseFloat(token2value) || 0) && token1Details?.symbol && token2Details?.symbol && (
                loading ? (
                    <button
                        className="bg-perpx-cyan my-4 w-full rounded-[64px] py-[16px] px-[4px] text-perpx-dark text-[18px] font-semibold hover:shadow-perpx-glow-lg transition-all"
                        disabled
                    >
                        Loading..
                    </button>
                ) : (
                    <button
                        className="bg-perpx-cyan my-4 w-full rounded-[64px] py-[16px] px-[4px] text-perpx-dark text-[18px] font-semibold hover:shadow-perpx-glow-lg hover:scale-[1.02] transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                        disabled={
                            !selected?.symbol || !selectedBuy?.symbol || !token1value || !token2value || token1value <= 0 || token2value <= 0
                        }
                        onClick={addLiquidity}
                    >
                        Add Liquidity
                    </button>
                )
            )}
            {" "}
            <div className="bg-perpx-dark-secondary/80 w-full text-perpx-text-primary flex justify-between text-[16px] sm:text-[18px] rounded-[14px] font-medium px-2 py-2 border border-perpx-cyan/10 mb-8">
            {lpAddress ? 
                <h6>1 {token1Details.symbol} = {price} {token2Details?.symbol}{" "}</h6>
            : 
            <h6>{token1value} {token1Details.symbol} = {token2value} {token2Details?.symbol}{" "}</h6>
            }
                {/* <div className="flex justify-center items-center gap-2">
          <img src={gas} />
          <b className="text-[16px] sm:text-[18px] font-medium">$2.00</b>
        </div> */}
            </div>
            <TokenModal open={open} setOpen={setOpen} onClick={setSelected} />
            <TokenModal
                open={openBuy}
                setOpen={setOpenBuy}
                onClick={setSelectedBuy}
            />
            <SlippageSettings
                open={settingsOpen}
                setOpen={setSettingsOpen}
                slippage={slippage}
                setSlippage={setSlippage}
            />
        </div>
    );
};

export default AddLiquidity;
